import * as Y from 'yjs';

import {
  type CanvasTransactionOrigin,
  IMMEDIATE_ORIGINS,
} from '@canvas/transaction-types';

import { type Update } from '../network/abstract-batched-updates';
import { type UpdateMetadata } from '../network/yjs-socket';

export function mergeUpdate(
  updates: Update<Uint8Array<ArrayBuffer>, UpdateMetadata>[]
): Update<Uint8Array<ArrayBuffer>, UpdateMetadata> {
  const rawUpdates = updates.map((update) => update.payload);
  const update = new Uint8Array(Y.mergeUpdates(rawUpdates));

  // Prefer an immediate origin if one exists in the batch; otherwise
  // fall back to the last update's origin.
  const immediateUpdate = updates.find(
    (u) =>
      typeof u.origin === 'string' &&
      IMMEDIATE_ORIGINS.has(u.origin as CanvasTransactionOrigin)
  );
  const selectedUpdate = immediateUpdate ?? updates[updates.length - 1];

  // clientID and clock must come from the last update because the
  // merged payload includes all updates up to that point.
  return {
    payload: update,
    origin: selectedUpdate.origin,
    clientID: updates[updates.length - 1].clientID,
    clock: updates[updates.length - 1].clock,
  };
}
